<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="form-saf">
          <div class="container-page">
            <router-link to="/settings/mydocuments" class="d-flex align-items-center mb-4">
              <img src="@/assets/image/icon/cheveron-down.svg" class="mr-2" alt="">
              <p style="font-weight: 600;color: #686868;">Back</p>
            </router-link>
            <p class="mb-2" style="font-weight: 700;color: #1D3354;font-size: 18px;">Additional Form For Service Application Form (SAF)</p>
            <div>
              <component
              :is="CurrentTabComponent"
              @Draft="saveDraft"
              @Next="onSelectedTab"
              @Back="onSelectedTab" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modalSuccessUpload"
      ref="modalSuccessUpload"
      hide-footer
      hide-header-close
      centered
    >
      <div class="text-center">
        <img class="mb-2" src="@/assets/image/icon/success-blue.svg" alt="">
        <p class="mb-2">Progress has been saved as draft</p>
        <!-- <button @click="closeSuccessModal" class="button__bluecorporite">Ok</button> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import Form1 from '@/components/saf/form1.vue'
import Form2 from '@/components/saf/form2.vue'
import Form3 from '@/components/saf/form3.vue'
import Form4 from '@/components/saf/form4.vue'
import Form5 from '@/components/saf/form5.vue'
export default {
  name: 'SAF',
  components: {
    Sidebar,
    Form1,
    Form2,
    Form3,
    Form4,
    Form5
  },
  data () {
    return {
      selectedTab: 'form1',
      dataPayload: ''
    }
  },
  computed: {
    CurrentTabComponent () {
      if (this.selectedTab === 'form1') {
        return Form1
      } else if (this.selectedTab === 'form2') {
        return Form2
      } else if (this.selectedTab === 'form3') {
        return Form3
      } else if (this.selectedTab === 'form4') {
        return Form4
      } else if (this.selectedTab === 'form5') {
        return Form5
      }
    }
  },
  methods: {
    onSelectedTab (name) {
      this.selectedTab = name
    },
    async saveDraft (data) {
      const section1 = JSON.parse(localStorage.getItem('data'))
      await section1 !== null ? this.allData = {...section1, ...data} : this.allData = data
      await this.$store.dispatch('settingSaf/POST_SAF_SAVE_DRAFT', this.allData)
      await this.$eventHub.$emit('dialog-payload-save-draft', this.fetchSaf)
      await this.$refs.modalSuccessUpload.show()
      setTimeout(() => {
        this.closeSuccessModal()
      }, 1500)
    },
    closeSuccessModal () {
      this.$refs.modalSuccessUpload.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/saf/index.vue